export { default as NoLimitHoldemCompeteRoom } from "./NLHCompeteRoom.vue";
export { default as NoLimitHoldemDesktop } from "./NoLimitHoldemDesktop.vue";
export { default as NoLimitHoldemMobile } from "./NoLimitHoldemMobile.vue";
export { default as NoLimitHoldemCreateDrill } from "./CreateDrill.vue";
export { default as NoLimitHoldemDrillsPage } from "./DrillsPage.vue";

export { default as NLHSeat } from "./components/table/NLHSeat.vue";
export { default as PokerTable } from "./components/table/PokerTable.vue";
export { default as CreateDrillConfigPreflop } from "./components/CreateDrillConfigPreflop.vue";
export { default as CreateDrillConfigPostflop } from "./components/CreateDrillConfigPostflop.vue";

export { default as DrillFieldCheckboxGroup } from "./components/fields/DrillFieldCheckboxGroup.vue";

import PokerTablePreview2 from "./components/table/PokerTablePreview2.vue";
export { PokerTablePreview2 };

import CreateDrill from "./CreateDrill.vue";
import DrillsPage from "./DrillsPage.vue";
import image from "./main.vue";
import DrillEditor from "./DrillEditor.vue";

export const gameData = {
  key: "nlh",
  name: "NLHE",
  flavors: [],
  CreateDrill,
  DrillsPage,
  PreviewTable: PokerTablePreview2,
  image,
  locales: {
    en: {},
  },
  priority: 1,
};

export { useFlagsWithLocalStorage } from "./helpers/featureToggles/useFlagsWithLocalStorage";
export type { FlagValue } from "./helpers/featureToggles/useFlagsWithLocalStorage";
